import axios from "axios";
import { Dispatch } from "redux";
import { IsRunningOverwolf, generateConfig} from "../../../utilityFunctions";

import {
  REFRESH_USER_INFO, RESET_NOTIFICATION_POLLING,
} from "../actionTypes/types";

import { UserInfoInterface } from "../../../types";
import { refreshTokenHandler } from "../../../utilityFunctions";
import {GlobalError} from "../../../components/errors/GlobalError";
import { NavigateFunction } from "react-router-dom";

export const RefreshUserInfo =
  (accessToken: string, refreshToken: string, userInfo: UserInfoInterface, navigate: NavigateFunction, currentlyPolling: boolean) =>
  async (dispatch: Dispatch<any>) => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const config = generateConfig(accessToken);
    try {
      const refreshResponse = await axios.get(
        `${BASE_URL}/api/users/info`,
        config
      );
      if (refreshResponse.status === 200) {
        const payload = {userInfo: refreshResponse.data, accessToken: accessToken, refreshToken: refreshToken, currentlyPolling}
        console.log("this is payload in RefreshUserInfo", payload)
        dispatch({ type: REFRESH_USER_INFO, payload: payload });

        if ((refreshResponse?.data?.disabledInGameGeneralNotifications === false || refreshResponse?.data?.disabledInGameOrderTrackingNotifications === false) && IsRunningOverwolf() && !currentlyPolling) {
           dispatch({type: RESET_NOTIFICATION_POLLING, payload: true});
        }
      }
    } catch (error: any) {
      
      if (error.response?.status === 401) {
        const refreshedTokens = await refreshTokenHandler(
          refreshToken,
          userInfo,
          dispatch,
          navigate
        );
        const config = generateConfig(refreshedTokens?.accessToken);
        try {
          const refreshResponse = await axios.get(
            `${BASE_URL}/api/users/info`,
            config
          );
          if (refreshResponse.status === 200) {
            const payload = {userInfo: refreshResponse.data, accessToken: refreshedTokens?.accessToken, refreshToken: refreshedTokens?.refreshToken}
            dispatch({
              type: REFRESH_USER_INFO,
              payload: payload,
            });
            if ((refreshResponse?.data?.disabledInGameGeneralNotifications === false || refreshResponse?.data?.disabledInGameOrderTrackingNotifications === false) && IsRunningOverwolf() && !currentlyPolling) {
              dispatch({type: RESET_NOTIFICATION_POLLING, payload: true});
           }
          }
          
        } catch (error: any) {
          GlobalError(error);
        }
      } else {
        GlobalError(error);
      }
    }
  };